<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="pageloader">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
                <div class="row no-gutters mt-4">
                    <br />
                </div>
                <!-- <nav class="nav card-header1 d-flex justify-content-between  ml-3 mr-3 mt-2 p-2 mb-3" id="nav">
                  <div>
                    <span>
                      <input type="radio" id="html"> <label class="font14-opacity80 ml-2 proximanova">Select All</label>
                    </span>
                  </div>
                  <span class="font12-opacity60 mt-2 proximanova">2021-Jun</span>
                </nav> -->
              <div v-if="totalDraftJobsList.length < 1">
                <no-jobs-available></no-jobs-available>
              </div>
              <div v-if="totalDraftJobsList.length > 0">
                <div v-for="(job, index) in totalDraftJobsList" :key="index" >
                  <div class="card mr-3 ml-3 mb-3">
                    <div class="p-2 d-flex">
                      <div class="col-2 mr-2 mr-lg-0 mr-md-0">
                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-4 text-center">
                          <img v-if="job.companyProfileLink" :src="job.companyProfileLink" class="prof-img rounded-circle loadingBgImg" alt="companylogo">
                          <img v-else src="../assets/Profile_placehlder.svg" class="prof-img rounded-circle" alt="companylogo">
                        </div>
                      </div>
                      <div class="col-10 pl-0 pt-3">
                        <div class="d-flex justify-content-between">
                          <div>
                            <span class="fontsize24 black proximanova stylebold mt-lg-2 pointer" @click="viewJobDetails(job)">{{job.jobTitle}}</span>
                          </div>
                          <div class="row my-auto">
                            <span class="fontsizemd black stylebold proximanova mr-3 pointer d-none d-md-block" @click="viewJobDetails(job)">View Details</span>
                            <img src="../assets/horizontal_menu_icon.svg" width="20px" height="20px" v-popover = "{name: job.moremenu}"  class="mr-4 pointer more_optionhoriz" alt="moremenu">
                            <popover v-bind:name="job.moremenu"  class="postvideomenu" id="jobmenu">
                              <div class="p-1">                                        
                                <div class="d-flex p-1 pl-2 ml-1 action" @click="editJob(job)">
                                  <img src="../assets/Editvideo.svg" alt="edit" class="img-fluid">
                                  <span class="p-2 font14-opacity80 proximanova">Edit</span>
                                </div>
                                <div class="d-flex p-1 pl-2 ml-1 action" @click="deleteJob(job)">
                                  <img src="../assets/Deletevideo.svg" alt="delete" class="img-fluid">
                                  <span class="p-2 font14-opacity80 proximanova">Delete</span>
                                </div>
                              </div>
                            </popover>
                          </div>
                        </div>
                        <div class="d-flex flex-column">
                          <div class="d-flex" v-if="job.jobPostedByResponse && job.jobPostedByResponse.jobPostedByFirstName">
                            <img v-if="job.jobPostedByResponse.jobPostedprofilePicLink" :src="job.jobPostedByResponse.jobPostedprofilePicLink" width="25px" height="25px" class="rounded-circle loadingBgImg" alt="companylogo">
                            <span class="fontsizemd black proximanova mt-1 ml-1">{{job.jobPostedByResponse.jobPostedByFirstName}} {{job.jobPostedByResponse.jobPostedByLastName}}</span>
                          </div>
                          <span class="fontsize16 black proximanova mt-1">{{job.companyName}}</span>
                          <div>
                            <span class="fontsizemd black60 proximanova">{{job.industry}}</span>
                            <span class="ml-2 mr-2 black60">|</span>
                            <span class="fontsizemd black60 proximanova">{{job.country}}</span>
                          </div>
                        </div>
                        <div class="d-flex mt-2 justify-content-between">
                          <div class="mt-1">
                            <!-- <span class="fontsizemd black stylebold proximanova">{{job.creationD | moment("from", "now", true)}} ago</span> -->
                            <span class="fontsizemd black  proximanova-semibold">{{ job.creationD | moment("MMM Do YYYY, h:mm a") }}</span>
                            <span class="ml-2 mr-2 black60"> - </span>
                            <span class="fontsizemd black60 proximanova">Hiring Within 7 days</span>
                          </div>
                        </div>
                        <div class="d-flex pt-2 pb-2 justify-content-between">
                          <div class="pt-1">
                             <!-- <a class="btn button-create btn-color mr-2 "  id="search">
                                <span class="fontsize14 proximanova">Save</span>
                              </a> -->
                              <!-- <button class="btn button-create blackbackhroundsignin mouseoverbtn2"  id="search">
                                  <span class="fontsize14 white proximanova">Post</span>
                              </button> -->
                          </div>
                        </div>
                      </div>
                    </div>                   
                  </div>
                </div>
                <div class="col-12 pb-5 mb-4" v-if="instancepageloader">
                  <img src="../assets/pageloader.svg" class="instancepageloader" alt="pageloader">
                </div>
              </div>
            </div>
          </div>
        </div>
        <view-selected-job-details v-if="viewJobDetailsModal" :JobObject="JobObject" @closePreviewModal="closePreviewModal"></view-selected-job-details>
        <delete-job-modal v-if="deleteJobModal" :deleteJobObject="deleteJobObject" @closeDeleteJobModal="closeDeleteJobModal"></delete-job-modal>
        <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import httpbusiness from "@/js/http-business.js"
import httpjob from "@/js/http-postjob.js"
import router from '../router.js'
import { bus } from "@/main.js";
import deleteJobModal from '../components/DeleteJobComponent.vue'
import noJobsAvailable from '../components/NoJobsAvailable.vue'
import viewSelectedJobDetails from '../components/ViewJobDetailsModal.vue'
import APIErrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from "@/js/session-util.js";
Vue.use(Popover);
export default{
    components:{
      deleteJobModal,
      noJobsAvailable,
      viewSelectedJobDetails,
      APIErrorModal
    },
    data(){
        return{
          displayAPIerrorModal : false,
            pageloader: true,
            instancepageloader : false,
            companyProfileId : null,
            employeeId : null,
            totalDraftJobsList : [],
            instancedraftJobsList : [],
            isScrolled : false,
            limit : 10,
            offset : 0,
            deleteJobModal : false,
            deleteJobObject : {
              jobId : ''
            },
            JobObject : {},
            viewJobDetailsModal : false,
            //if recruiter login
            recruiterAccountStatus : 'ACCEPT'
        }
    },
    created (){
        
    },
    methods:{
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      closePreviewModal(statusObj) {
          console.log(statusObj)
          this.viewJobDetailsModal = false;
      },
      viewJobDetails(job) {
        console.log(job)
        this.JobObject = job;
        this.viewJobDetailsModal = true;
        // this.$session.set("selectedJobId", job.jobId);
        // router.push({
        //   name : 'viewjob'
        // })
      },
      editJob(job){
        console.log(job)
        sessionUtils.setSelectedJobId(job.jobId)
        router.push({
          name : 'editjob'
        })
      },
      deleteJob(job){
        console.log(job)
        this.deleteJobObject.jobId = job.jobId;
        this.deleteJobModal = true;
        // var vm = this;
        // httpjob.put('/postjob/updateJobStatusById?jobId='+job.jobId+'&jobStatus=DELETE')
        // .then((response) => {
        //   console.log(response)
        //   vm.$toast.success(response.data.errorMessage)
        //   this.resetData()
        // }).catch((e) => {
        //   console.log(e)
        //   vm.$toast.error(e.data.errorMessage)
        // })
      },
      //this will invoke after click on close btn in delete job modal component
      closeDeleteJobModal(statusObj) {
        this.deleteJobModal = false;
        if(statusObj === 'SUCCESS') {
          this.resetData()
        }
        console.log("delete job : ", statusObj)
      },
      resetData(){
        this.offset = 0;
        this.pageloader = true;
        this.instancedraftJobsList = [];
        this.totalDraftJobsList = [];
        this.getDraftJobsList()
      },
      // get list of draft jobs
      getDraftJobsList(){
        var vm = this;
        httpjob.get('/postjob/getListByJobStatus?companyProfileId='+this.companyProfileId+'&employeeId='+this.employeeId+'&jobStatus=DRAFT&&limit='+this.limit+'&offset='+this.offset)
        .then((response) => {
          this.pageloader = false;
          this.instancepageloader = false;
          this.isScrolled = false;
          console.log(response)
          this.instancedraftJobsList = response.data;
          if(this.instancedraftJobsList.length > 0){
            for(var i =0; i < this.instancedraftJobsList.length; i++){
              this.instancedraftJobsList[i].moremenu = "closemore"+this.instancedraftJobsList[i].jobId
              this.totalDraftJobsList.push(this.instancedraftJobsList[i])
            }
          }
          if(this.instancedraftJobsList.length < 1) {
            vm.$toast.success("No More Jobs available")
          }
          // this.jobsList = response.data;
        }).catch((e) => {
          console.log(e.response)
          this.instancepageloader = false;
          this.pageloader = false;
          this.displayAPIerrorModal = true;
        })
      },
      //this will invoke after scrolling down to get more records
      draftJobsPageScroll () {
        if(!this.isScrolled && this.instancedraftJobsList.length > 0){               
          if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown && !this.noResults) {            
            this.isScrolled = true;    
            this.instancepageloader = true
            this.offset = this.offset+10;
            this.getDraftJobsList()        
          }        
        }
      },
    },
    mounted() {
      window.scrollTo(0, 0);
      this.companyProfileId = sessionUtils.getCompanyProfileId();
      this.employeeId = sessionUtils.getBusinessAccountId();
      if(sessionUtils.getmodule() == 'Recruiter'){
        this.recruiterAccountStatus = sessionUtils.getRecruiterAccountStatus()
      }
      if(this.companyProfileId && this.companyProfileId!='undefined' && this.companyProfileId != 'null'&& this.recruiterAccountStatus=='ACCEPT'){
      this.getDraftJobsList()
      }else{
        this.pageloader = false;
      }
      bus.$on("refreshDraftJobsList", data => {
        if(data){
          this.resetData()
        }
      })
    },
    created(){
      window.addEventListener('scroll', this.draftJobsPageScroll);
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.draftJobsPageScroll);
      bus.$off('refreshDraftJobsList')
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.jobsection{
  overflow-x: auto;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.dot{
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: tomato;
}
select > option{
  background-color: white;
  color: black;
}
.btn-color{
  border-color: #1F1F1F;
}
.btn{
    width: 80px;
}
.action:hover{
  background: #dddfe5;
  border-radius: 10px;
  cursor: pointer;
}
.instancepageloader{
  width: 7%;
  margin-left: 48%;
  margin-top: 2%;
  margin-bottom: 2%;
}
.prof-img{
  width: 50px;
  height: 50px
}
.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
 .dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 140px !important;
    left: unset !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
@media screen and (min-width: 550px) and (max-width: 768px) {
   .dropdown-position-bottom.postvideomenu {
    transform: translate3d(-10%,0,0);
  }  
}
@media screen and  (max-width: 550px) {
   .dropdown-position-bottom.postvideomenu {
    transform: translate3d(-75%,0,0);
  }  
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .fontsize24{
    font-size: 16px
  }
   .prof-img {
    width: 36px;
    height: 36px;
}
  
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
